module.exports = __webpack_public_path__ + "static/media/sf-test-11.96ac7857.mp3";